import React from 'react';

import { Routes } from 'react-router-dom';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring/SentryRoute';

import { PageError } from '../../../layout';
import { AuthById } from '../AuthById';
import { AuthList } from '../AuthList';

import { Greeting } from './Greeting';
import { Qr } from './Qr';
import { VerifyPassCode } from './VerifyPassCode';
import { Login } from './Login';
import { Register } from './Register';

export const AliAuth = () => {
  return (
    <Routes>
      <Route path="login" element={<Greeting />} />
      <Route path="qr" element={<Qr />} />
      <Route path="pass" element={<VerifyPassCode />} />
      <Route path="ali" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="auth-list" element={<AuthList />} />
      <Route path=":id/*" element={<AuthById />} />
      <Route
        path="*"
        element={
          <div>
            <PageError status={404} />
          </div>
        }
      />
    </Routes>
  );
};
